module.exports = __webpack_public_path__ + "static/kreston-background-fe993fcce257101d9dd4717c535ab16f.png";